import { render, staticRenderFns } from "./jpointLog.vue?vue&type=template&id=3c0233ff&scoped=true"
import script from "./jpointLog.vue?vue&type=script&lang=js"
export * from "./jpointLog.vue?vue&type=script&lang=js"
import style0 from "./jpointLog.vue?vue&type=style&index=0&id=3c0233ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0233ff",
  null
  
)

export default component.exports